/**
 * Ad Components Index
 * Exports all ad-related components for easy importing
 */

// Core components
export { default as AdsenseAd } from './AdsenseAd';
export { default as AdProvider } from './AdProvider';

// Strategic placement components
export {
  BelowTitleAd,
  FirstParagraphAd,
  MidContentAd,
  EndContentAd,
  SideAd,
  InFeedAd,
  StickyMobileAd
} from './AdPlacement';

// Example implementations
export { default as CardListWithAds } from './examples/CardListWithAds';
export { default as ArticleWithAds } from './examples/ArticleWithAds';
